import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TextbausteinConfig } from '../../../directives/text-baustein.directive';
import { HeimtierBeleg, HeimtierBelegStatus } from '../../heimtier-beleg';
import { KieneBackendApiService } from '../../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Component({
    selector: 'kiene-besuchs-detail-beleg',
    templateUrl: './besuchs-detail-beleg.component.html',
    styleUrls: ['./besuchs-detail-beleg.component.scss'],
})
export class BesuchsDetailBelegComponent implements OnInit, OnChanges {
    @Input() heimtierBeleg: HeimtierBeleg;
    @Output() validationChange = new EventEmitter<boolean>();

    public berichtCtrl: FormControl = new FormControl();
    protected zusammenfassungCtrl: FormControl = new FormControl();
    protected anmerkungCtrl: FormControl = new FormControl();
    @Output() heimtierBelegChange = new EventEmitter<HeimtierBeleg>();

    constructor(
        private api: KieneBackendApiService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private messageService: MessageService,
    ) {}

    ngOnInit(): void {}

    ngOnChanges() {
        this.initFormFields();
    }

    public getTextBausteinZusammenfassung(): TextbausteinConfig {
        const textbaustein = new TextbausteinConfig();
        textbaustein.count = 1;
        textbaustein.titel1 = 'Besuchszusammenfassung';
        textbaustein.text1 = this.zusammenfassungCtrl.value;
        textbaustein.typ1 = 'besuchszusammenfassung';

        return textbaustein;
    }

    public getTextBausteinBericht(): TextbausteinConfig {
        const textbaustein = new TextbausteinConfig();
        textbaustein.count = 1;
        textbaustein.titel1 = 'Bericht';
        textbaustein.text1 = this.berichtCtrl.value;
        textbaustein.typ1 = 'bericht';

        return textbaustein;
    }

    public getTextBausteinAnmerkung(): TextbausteinConfig {
        const textbaustein = new TextbausteinConfig();
        textbaustein.count = 1;
        textbaustein.titel1 = 'Anmerkung';
        textbaustein.text1 = this.anmerkungCtrl.value;
        textbaustein.typ1 = 'besuch';

        return textbaustein;
    }

    updateBeleg() {
        if (this.heimtierBeleg.status_id === HeimtierBelegStatus.ABGESCHLOSSEN) {
            return;
        }
        this.heimtierBeleg.bericht = this.berichtCtrl.value;
        this.heimtierBeleg.besuchszusammenfassung = this.zusammenfassungCtrl.value;
        this.heimtierBeleg.anmerkung = this.anmerkungCtrl.value;
        this.api.updateGeneric(this.apiBaseUrl + 'heimtier_beleg/update.php', this.heimtierBeleg).subscribe({
            next: response => {
                this.heimtierBeleg = response;
                this.heimtierBelegChange.emit(this.heimtierBeleg);
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Speichern!', err);
            },
        });
    }

    private initFormFields() {
        this.berichtCtrl.setValue(this.heimtierBeleg?.bericht);
        this.zusammenfassungCtrl.setValue(this.heimtierBeleg?.besuchszusammenfassung);
        this.anmerkungCtrl.setValue(this.heimtierBeleg?.anmerkung);
        if (this.heimtierBeleg?.status_id === 223) {
            this.berichtCtrl.disable();
            this.zusammenfassungCtrl.disable();
            this.anmerkungCtrl.disable();
        }
    }
}
